import { render, staticRenderFns } from "./flowSupervise.vue?vue&type=template&id=36f2fe78&scoped=true&"
import script from "./flowSupervise.vue?vue&type=script&lang=js&"
export * from "./flowSupervise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f2fe78",
  null
  
)

export default component.exports